module.exports = __webpack_public_path__ + "img/header-bg.7f92ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/header-bg.png
// module id = hcWL
// module chunks = 1